export default {
  name: 'Toronto Global Forum',
  shortName: 'Toronto',
  description:
    'Le Toronto Global Forum a été lancé en 2006 et rassemble des leaders d’opinion internationaux issus du monde des affaires, du gouvernement et de la société civile pour discuter des principaux défis, et des opportunités qui en découlent, auxquels l’économie mondiale est actuellement confrontée.',
  thumbnail: '/images/events/toronto/thumbnail-toronto.jpg',
  link: 'https://www.torontoglobalforum.com/',
  header: {
    content:
      'Le Toronto Global Forum (TGF) a été lancé en 2006 et rassemble des leaders d’opinion internationaux issus du monde des affaires, du gouvernement et de la société civile pour discuter des principaux défis, et des opportunités qui en découlent, auxquels l’économie mondiale est actuellement confrontée.'
  },
  bullets: {
    bullet1: {
      number: '17ème',
      label: 'Édition'
    },
    bullet2: {
      number: '2 500+',
      label: 'Participants'
    },
    bullet3: {
      number: '140+',
      label: 'Conférenciers'
    },
    bullet4: {
      number: '65+',
      label: 'Pays Représentés'
    }
  },
  about: {
    title: 'Notre objectif',
    content:
      'Le Toronto Global Forum sert de plateforme où les organisations et les institutions peuvent se rencontrer en se concentrant sur les partenariats potentiels, les opportunités d’investissement et les collaborations futures. Alors que les pays et les industries cherchent des moyens d’améliorer la résilience économique et environnementale et de favoriser le développement sociétal, la conférence vise à explorer ces sujets dans une optique internationale.'
  },
  next: {
    title: 'Fostering Economic Resilience',
    content:
      "En cette période de grande incertitude dans le monde entier, la conférence examinera comment nous pouvons nous adapter afin d'encourager l'innovation et la résilience au vu des actualités mondiales et du climat économique actuel. Rejoignez des dirigeants et des décideurs du monde entier pour trois jours de discussions dynamiques sur les sujets clés de notre époque, tout en profitant d’une variété d’opportunités de réseautage, y compris de déjeuners et de réceptions."
  },
  gallery: {
    title: 'Galerie de photos',
    index: [
      {
        title: '16ème édition — Charting a new economy',
        images: [
          '/images/events/toronto/gallery/16th-toronto-001.jpg',
          '/images/events/toronto/gallery/16th-toronto-002.jpg',
          '/images/events/toronto/gallery/16th-toronto-003.jpg',
          '/images/events/toronto/gallery/16th-toronto-004.jpg',
          '/images/events/toronto/gallery/16th-toronto-005.jpg',
          '/images/events/toronto/gallery/16th-toronto-006.jpg',
          '/images/events/toronto/gallery/16th-toronto-007.jpg',
          '/images/events/toronto/gallery/16th-toronto-008.jpg',
          '/images/events/toronto/gallery/16th-toronto-009.jpg'
        ]
      }
    ]
  },
  board: {
    uptitle: 'À propos',
    title: 'Conseil aviseur',
    content:
      'Les membres de la direction du Toronto Global Forum travaillent en étroite collaboration avec un groupe d’individus rigoureusement sélectionnés qui forment notre comité aviseur. Tous les membres du comité aviseur du Toronto Global Forum ont été soigneusement désignés pour leurs connaissances approfondies et leur expérience dans leurs domaines respectifs.'
  },
  boardIndex: {
    chairmens: {
      title: 'Président',
      index: [
        {
          name: 'John M. Beck',
          title: '',
          info: 'Founder and Chairman at Aecon & and Chairman of the Advisory Board at the Toronto Global Forum',
          image: '/images/boards/toronto/John-M-Beck.png'
        }
      ]
    },
    members: {
      title: 'Membres',
      index: [
        {
          name: 'Bertrand Badré',
          info: 'Chief Executive Officer and Founder, Blue Orange Capital',
          image: '/images/boards/toronto/Bertrand-Badre.jpg'
        },
        {
          name: 'Dan Barclay',
          info: 'Chief Executive Officer & Group Head, BMO Capital Markets',
          image: '/images/boards/toronto/Barclay-Dan.png'
        },
        {
          name: 'Christiane Bergevin',
          info: 'President, Bergevin Capital and Past Chair of the Board, Canadian Chamber of Commerce',
          image: '/images/boards/toronto/Christiane-Bergevin.png'
        },
        {
          name: 'Stefanie Crosby',
          info: 'President and Chief Visionary Officer, Triumspear International',
          image: '/images/boards/toronto/Crosby-Stefanie.png'
        },
        {
          name: 'Janet De Silva',
          info: 'President and Chief Executive Officer, Toronto Region Board of Trade',
          image: '/images/boards/toronto/Janet-De-Silva.jpg'
        },
        {
          name: "Craig D'Souza",
          info:
            'Vice President of Global Security, Intelligence, Protective Intelligence, Investigations & Protective Services, Facebook',
          image: '/images/boards/toronto/Craig-DSouza.png'
        },
        {
          name: 'Mairead Lavery',
          info: 'President and Chief Executive Officer, Export Development Canada (EDC)',
          image: '/images/boards/toronto/Lavery-Mairead.png'
        },
        {
          name: 'Joseph S. Mancinelli',
          info:
            'International Vice President and Regional Manager of Central and Eastern Canada, Labourers International Union of North America (LiUNA)',
          image: '/images/boards/toronto/Joseph-S-Mancinelli.jpg'
        },
        {
          name: "Allan O'Dette",
          info: 'Canadian Business Leader and former Chief Executive Officer, Ontario Medical Association',
          image: '/images/boards/toronto/odette-allan-2016.png'
        },
        {
          name: 'Benoit Parent',
          info: 'Vice-President, Power Generation Business and Nuclear Operations, Cummins Sales and Service',
          image: '/images/boards/toronto/benoit-parent.jpg'
        },
        {
          name: 'Neil Pakey',
          info: 'President & CEO, Nieuport Aviation',
          image: '/images/boards/toronto/Neil_Packey.jpg'
        },
        {
          name: 'Lisa Raitt',
          info: 'Vice-Chair, Global Investment Banking, CIBC Capital Markets',
          image: '/images/boards/toronto/Raitt-Lisa.jpg'
        },
        {
          name: 'Nicholas Rémillard',
          info: 'Chief Executive Officer, International Economic Forum of the Americas (IEFA)',
          image: '/images/boards/toronto/Nicholas-Rémillard.jpg'
        },
        {
          name: 'Dimitri Soudas',
          info: 'Chairman, Letho Resources; Vice-President, Groupe Selection, Co-Founder Kids Inc',
          image: '/images/boards/toronto/Dimitri-Soudas.png'
        },
        {
          name: 'Jeffrey Steiner',
          info: 'Founder and Owner, New Franchise Media',
          image: '/images/boards/toronto/Jeffrey-Steiner.jpg'
        },
        {
          name: 'Kenneth Tanenbaum',
          info: 'Chairman, Kilmer Developments; and Vice-Chairman, Kilmer Van Nostrand (KVN)',
          image: '/images/boards/toronto/tanenbaum-ken.jpg'
        },
        {
          name: 'Douglas E. Turnbull',
          info: 'Vice-Chairman and Country Head, Canada',
          image: '/images/boards/toronto/turnbull-douglas-2016.jpg'
        },
        {
          name: 'Sonja Volpe',
          info: 'President and Chief Executive Officer, BNP Paribas Canada',
          image: '/images/boards/toronto/Volpe-Sonja.png'
        },
        {
          name: 'Geoffrey A. Wilson',
          info: 'Canadian Business Leader and former President and Chief Executive Officer, PortsToronto',
          image: '/images/boards/toronto/wilson-geoff.jpg'
        },
        {
          name: 'Paul Zed',
          info: 'National Counsel, McCarthy Tetrault',
          image: '/images/boards/toronto/zed-paul.png'
        }
      ]
    }
  }
}
